import { writeErr } from '../components/common/logger';
import { getHostApi, apiGet, apiPost } from './apiWrapper';

const IA_REQUEST = "IA_REQUEST";
const IA_SUCCESS = "IA_SUCCESS";
const IA_FAILURE = "IA_FAILURE";
const IA_PDF_EXPORT = "IA_PDF_EXPORT";

export const IA_TYPES = {
    financialRatios: "fr",
    structuralIndicators: "si"
};

const INITIAL_STATE = {
    isLoading: false,
    data: null,
    error: false,
    year: null,
    okec: null,
    type: null
};

export const industryAnalysisActions = {
    getFinancialRatios: (year, okec) => async (dispatch) => _getFinancialRatios(year, okec, dispatch),
    getStructuralIndicators: (year, okec) => async (dispatch) => _getStructuralIndicators(year, okec, dispatch),
    exportToPdf: (type, year, okec) => async (dispatch) => _exportToPdf(type, year, okec, dispatch)
}

export const reducer = (state, action) => {
    state = state || INITIAL_STATE;

    switch (action.type) {
        case IA_REQUEST:
            return { ...INITIAL_STATE, isLoading: true, year: action.year, okec: action.okec, type: action.iaType };
        case IA_SUCCESS:
            return { ...state, isLoading: false, error: false, data: action.data };
        case IA_FAILURE:
            return { ...state, isLoading: false, error: true, data: action.data };
        default:
            return state;
    }
}

function _getFinancialRatios(year, okec, dispatch) {
    dispatch({ type: IA_REQUEST, year: year, okec: okec, iaType: IA_TYPES.financialRatios });
    apiGet(`${getHostApi()}/api/industry-analysis/financial-ratios?year=${year}&okec=${okec}`, null,
        (s) => dispatch({ type: IA_SUCCESS, data: s.data }),
        (e) => {
            writeErr(e);
            dispatch({ type: IA_FAILURE })
        }
    );
}

function _getStructuralIndicators(year, okec, dispatch) {
    dispatch({ type: IA_REQUEST, year: year, okec: okec, iaType: IA_TYPES.structuralIndicators });
    apiGet(`${getHostApi()}/api/industry-analysis/structural-indicators?year=${year}&okec=${okec}`, null,
        (s) => dispatch({ type: IA_SUCCESS, data: s.data }),
        (e) => {
            writeErr(e);
            dispatch({ type: IA_FAILURE })
        }
    );
}

function _exportToPdf(type, year, okec, dispatch){
    dispatch({ type: IA_PDF_EXPORT });
    apiPost(`${getHostApi()}/api/industry-analysis/pdf-export`, null, { type: type, year: parseInt(year), okec: okec })
}
